import React, { useState } from "react";

import { useAppDispatch } from "../../../../app/hooks";
import StageWorkflowAssignOfficerModal from "../../../stageWorkflow/components/StageWorkflowAssignOfficerModal";
import { AddStageRequest, CaseStageAction, CaseStageEnum } from "../../../../../src/api/caseStages";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import { getInvestigators } from "../../../users/logic/slice";
import { updateCaseStage } from "../../logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../lib/toast";
import { sortOptions } from "../../../../lib/utils";

export const AssignIO: React.FC<{
  next_stage: CaseStageEnum
}> = ({next_stage}) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();
  const investigators = useAppSelector(getInvestigators);
  
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const investigatorOptions = sortOptions(
    investigators?.map((user) => ({ 
      name: user.user_name || "", 
      value: user.user_id || "" 
    })) ?? []
  );        

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    setIsModalOpen(false);
  };

  const handleAccept = async (selectedInvestigator: string) => {
    if (!caseId || !selectedInvestigator) return;
    
   try {
         setIsLoading(true);
   
         const request: AddStageRequest = {
           stage: next_stage,
           source_action: CaseStageAction.ASSIGN_IO,
           stage_data: {
             investigator_id: selectedInvestigator,
           },
         };
   
         await dispatch(
           updateCaseStage({
             caseId,
             request,
           }),
         ).unwrap();
   
         showSuccessToast("Investigating Officer has been assigned successfully.");
         setIsModalOpen(false);
       } catch (error) {
          console.log(error);
         showErrorToast("Unable to assign the Investigating Officer. Please try again.");
       } finally {
         setIsLoading(false);
       }
  };

  return (
    <>
      <AcceptButton label="Assign" onClick={handleOpen} />

      <StageWorkflowAssignOfficerModal
        isOpen={isModalOpen}
        options={investigatorOptions}
        onClose={handleClose}
        onConfirm={handleAccept}
        title="Appoint Investigating Officer"
        loading={isLoading}
      />
    </>
  );
};
